var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-icon-rectangle card-component",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"w-2/5 flex justify-center"},[_c('i',{staticClass:"icon-cinergia flex justify-end pl-2",class:[_vm.icon]})]),_vm._v(" "),_c('p',{staticClass:"w-3/5 ml-6"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }